import { render, staticRenderFns } from "./order-handlings-component.vue?vue&type=template&id=383bab3e"
import script from "./order-handlings-component.vue?vue&type=script&lang=js"
export * from "./order-handlings-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports